import React from "react";

export const PageIntro = ({ title, subtitle, actions }) => (
  <div className="flex flex-wrap items-end justify-between gap-3 mb-6">
    <div>
      <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">{title}</h2>
      {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </div>
);

export const Empty = ({ text }) => (
  <div className="py-16 text-center text-sm text-muted-foreground" data-testid="empty-state">
    {text || "No records yet."}
  </div>
);
